module.exports = __webpack_public_path__ + "img/menu_njjl_c.a9bafd8a.png";